import { render } from "./VacunaPlan.vue?vue&type=template&id=6ad68976&scoped=true"
import script from "./VacunaPlan.vue?vue&type=script&lang=js"
export * from "./VacunaPlan.vue?vue&type=script&lang=js"

import "./VacunaPlan.vue?vue&type=style&index=0&id=6ad68976&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad68976"]])

export default __exports__